export const NCFileLevels = {
  GENERAL: 'general',
  TIMES: 'times',
};

export const timePeriod = {
  YEAR: 'year',
  MONTH: 'month',
  WEEK: 'week',
  DAY: 'day',
  NOW: 'now',
  SCHEDULED: 'scheduled',
  BATCHES: 'batches',
  PROPERTIES: 'properties',
  LINKS: 'links',
};

export const timeLine = [
  { flag: 'machine-year', value: timePeriod.YEAR },
  { flag: 'machine-month', value: timePeriod.MONTH },
  { flag: 'machine-week', value: timePeriod.WEEK },
  { flag: '', value: timePeriod.DAY },
  { flag: '', value: timePeriod.NOW },
  { flag: 'machine-scheduled', value: timePeriod.SCHEDULED },
];

export const LEVELS = {
  ALL: 'All',
  Parts: 'Parts',
  Operations: 'Operations',
  ProductionBatches: 'ProductionBatches',
  ProductionOrders: 'ProductionOrders',
  NCFiles: 'NCFiles',
  Tools: 'Tools',
  ImagesDocuments: 'ImagesDocuments',
  DetailsScreenImagesDocuments: 'Details Screen Images Documents',
  Machines: 'Machines',
  Persons: 'Persons',
};

export const LEVELS_WITH_FLAGS = {
  ALL: { key: 'All', name: 'All', flag: null },
  Parts: { key: 'Parts', name: 'Parts', flag: null },
  ProductionOrders: { key: 'ProductionOrders', name: 'Production Orders', flag: 'search-production-orders' },
  Operations: { key: 'Operations', name: 'Jobs', flag: 'search-productionoperation' },
  ProductionBatches: { key: 'ProductionBatches', name: 'Batches', flag: null },
  NCFiles: { key: 'NCFiles', name: 'NC Files', flag: null },
  Tools: { key: 'Tools', name: 'Tools', flag: null },
  ImagesDocuments: { key: 'ImagesDocuments', name: 'Images & Documents', flag: 'search-image-documents' },
  Machines: { key: 'Machines', name: 'Machines', flag: null },
  Persons: { key: 'Persons', name: 'Persons', flag: null },
};

export const PART_LEVELS = {
  All: 'All',
  Active: 'Active',
  Inactive: 'Inactive',
};

export const NC_FILE_LEVELS = {
  All: 'All',
  Update: 'Update NC File Type',
  Productive: 'Productive',
  Change: 'Change',
  Ignored: 'Ignored',
};

export const TOOL_LEVELS = {
  All: 'All',
  Active: 'Active',
  Inactive: 'Inactive',
};

export const IMAGE_DOCUMENTS_LEVELS = {
  All: 'All',
  Untagged: 'Untagged',
  Image: 'Image',
  Document: 'Document',
};

export const wallboardLevelNames = {
  now: 'Now',
  today: 'Timeline Today',
  last24: 'Timeline Last 24 Hours',
};

export const searchDisplayMode = {
  infoTiles: 'infoTiles',
  tableStandard: 'standard',
  tableCompact: 'compact',
  line: 'line',
  block: 'block',
  square: 'square',
  gallery: 'gallery',
};

export const searchDisplayModeTitles = {
  [searchDisplayMode.infoTiles]: 'Info Tiles',
  [searchDisplayMode.tableStandard]: 'Standard List',
  [searchDisplayMode.tableCompact]: 'Compact List',
  [searchDisplayMode.square]: 'Images',
  [searchDisplayMode.line]: 'List',
  [searchDisplayMode.block]: 'Square Tiles',
};
